import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {BsModalService, ModalModule} from 'ngx-bootstrap/modal';
import {ButtonsModule} from 'ngx-bootstrap/buttons';

import {MainComponent} from './main/main.component';
import {RouterModule} from '@angular/router';
import {PageHeaderComponent} from './page-header/page-header.component';
import {PageFooterComponent} from './page-footer/page-footer.component';
import {PageModule, SpinnerModule, UtilsModule} from '@gallaghercp/core-frontend';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {LoginComponent} from './login/sso/login.component';
import { ManualLoginComponent } from '@core-app/layout/login/manual/login.component';
import {TranslateModule} from '@ngx-translate/core';

import {MatTabsModule} from '@angular/material/tabs';
import {MatExpansionModule} from '@angular/material/expansion';
import {FabShortcutComponent} from './fab-shortcut/fab-shortcut.component';
import {MaintenanceComponent} from './maintenance/maintenance.component';
import {BlockHeroHeaderComponent} from '../blocks/block-hero-header/block-hero-header.component';
import {BlockValueStatementComponent} from '../blocks/block-value-statement/block-value-statement.component';
import {BlockCompanyPromiseComponent} from '../blocks/block-company-promise/block-company-promise.component';
import {BlockFinancialRewardsComponent} from '../blocks/block-financial-rewards/block-financial-rewards.component';
import {BlockTimeRewardsComponent} from '../blocks/block-time-rewards/block-time-rewards.component';
import {BlockAddedExtrasComponent} from '../blocks/block-added-extras/block-added-extras.component';
import {BlockMaximiseRewardsComponent} from '../blocks/block-maximise-rewards/block-maximise-rewards.component';
import {BlockStatementAbstractComponent} from '../blocks/block-statement-abstract.component';
import {BackPageForPdfComponent} from './back-page-for-pdf/back-page-for-pdf.component';
import {RecaptchaModule} from 'ng-recaptcha';
import {LogoutComponent} from './login/logout.component';
import {PrintComponent} from '../pages/print.component';
import {ToggleFiguresComponent} from './toggle-figures/toggle-figures.component';
import {FloatingFooterComponent} from './floating-footer/floating-footer.component';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {
    BlockOtherValuableBenefitsComponent
} from '@core-app/blocks/block-other-valuable-benefits/block-other-valuable-benefits.component';
import {
    BlockTotalRewardsSummaryComponent
} from '@core-app/blocks/block-total-rewards-summary/block-total-rewards-summary.component';
import {FooterComponent} from '@core-app/layout/footer/footer.component';
import {CoreFinancialDirective} from '@core-app/directives/financialsDirective';
import {
    BlockCompensationHistoryComponent
} from '@core-app/blocks/block-compensation-history/block-compensation-history.component';
import { BlockPaidTimeOffComponent } from '@core-app/blocks/block-paid-time-off/block-paid-time-off.component';
import {SwiperModule} from "@gallaghercp/core-swiper";

@NgModule({
    declarations: [
        MainComponent,
        MaintenanceComponent,
        PageHeaderComponent,
        PageFooterComponent,
        LoginComponent,
        ManualLoginComponent,
        LogoutComponent,
        FabShortcutComponent,
        BlockStatementAbstractComponent,
        BlockHeroHeaderComponent,
        BlockValueStatementComponent,
        BlockCompanyPromiseComponent,
        BlockFinancialRewardsComponent,
        BlockTimeRewardsComponent,
        BlockAddedExtrasComponent,
        BlockMaximiseRewardsComponent,
        PrintComponent,
        BackPageForPdfComponent,
        ToggleFiguresComponent,
        FloatingFooterComponent,
        BlockOtherValuableBenefitsComponent,
        BlockTotalRewardsSummaryComponent,
        BlockCompensationHistoryComponent,
        FooterComponent,
        BlockPaidTimeOffComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        BsDropdownModule,
        ModalModule,
        ButtonsModule,
        FormsModule,
        ReactiveFormsModule,
        MatProgressBarModule,
        SpinnerModule,
        TranslateModule,
        MatTabsModule,
        PageModule,
        MatExpansionModule,
        UtilsModule,
        RecaptchaModule,
        TooltipModule,
        CoreFinancialDirective,
        NgOptimizedImage,
        SwiperModule
    ],
    exports: [
        MainComponent,
        CommonModule
    ],
    providers: [
        BsModalService
    ]
})
export class LayoutModule {

}
